import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
// Self-hosted fonts (bundled by Vite) — no Google Fonts <link> so the app works
// inside a Discord Activity, whose CSP blocks external font hosts. Family names
// ('Inter', 'Grenze') match theme/tokens.css exactly.
//
// Grenze replaced IM Fell DW Pica SC as the display face (2026-07-29). IM Fell
// shipped ONE weight (400) and was inherently small-caps, so every bold heading
// was synthesised by the browser; Grenze has real weights, so we load the three
// the UI actually asks for and bold headings are drawn, not faked.
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/grenze/400.css';
import '@fontsource/grenze/600.css';
import '@fontsource/grenze/700.css';
import { router } from './router.js';

/**
 * Client entry. Mounts the router (which contains the App theme shell and the
 * device-based `/` default: phones → /play, desktop → Store).
 */
const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root not found');

createRoot(rootEl).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
